<template>
    <div class="app-container">
        <div class="form-container">
            <div class="header-section">
                <a class="header-link" href="/b2b-services">Сервисы</a>
                <h1>Настройка банковских продуктов</h1>
            </div>

            <!-- Группировка по типам продуктов -->
            <div
                v-for="(productType, index) in productsArray"
                :key="index"
                class="product-type-section"
            >
                <div class="product-type-header">
                    <h3>{{ productType.title }}</h3>
                    <div class="product-actions">
                        <button class="icon-btn" @click="openAddDialog(productType.type)">
                            <span class="material-icons">add</span>
                        </button>
                        <!-- <button class="icon-btn error" @click="deleteAllProducts(productType.type, productType.title)">
                            <span class="material-icons">close</span>
                        </button> -->
                    </div>
                </div>
                <div class="products-grid">
                    <div
                        v-for="product in productType.offers"
                        :key="product.id"
                        class="product-card"
                        @click="openEditDialog(product)"
                    >
                        <button class="delete-btn" @click.stop="deleteProduct(product)">
                            <span class="material-icons">close</span>
                        </button>
                        <div class="product-content">
                            <img
                                v-if="product.image"
                                :src="product.image"
                                :alt="product.description"
                                class="product-logo"
                            >
                            <div class="product-name">{{ companyName(product.name) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Диалоговое окно -->
        <div v-if="dialog" class="dialog-overlay">
            <div class="dialog-container" @click.stop>
                <div class="dialog-header">
                    <h2>{{ editingProduct ? 'Редактирование оффера' : 'Настройка оффера' }}</h2>
                    <button class="close-btn" @click="dialog = false">
                        <span class="material-icons">close</span>
                    </button>
                </div>

                <div class="dialog-body">
                    <div class="form-group">
                        <label>Тип продукта</label>
                        <select
                            v-model="selectedProductType"
                            required
                            :class="{ error: errors.productType }"
                        >
                            <option v-for="(text, value) in productTypes"
                                    :key="value"
                                    :value="value ? value : selectedProductType">
                                {{ text }}
                            </option>
                        </select>
                        <div v-if="errors.productType" class="error-message">
                            Пожалуйста, выберите тип продукта
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <label>Название оффера</label>
                            <input
                                v-model="offerName"
                                type="text"
                                required
                                :class="{ error: errors.offerName }"
                                @input="clearError('offerName')"
                            >
                            <div v-if="errors.offerName" class="error-message">
                                Пожалуйста, введите название оффера
                            </div>

                            <label>Комиссия</label>
                            <input
                                v-model.number="premium"
                                type="number"
                                required
                                :class="{ error: errors.premium }"
                                @input="clearError('premium')"
                            >
                            <div v-if="errors.premium" class="error-message">
                                Пожалуйста, введите комиссию
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Изображение</label>
                            <input
                                v-model="imageLink"
                                type="text"
                                required
                                :class="{ error: errors.imageLink }"
                                @input="clearError('imageLink')"
                            >
                            <div v-if="errors.imageLink" class="error-message">
                                Пожалуйста, введите ссылку на изображение
                            </div>

                            <label>Реферальная ссылка</label>
                            <input
                                v-model="link"
                                type="text"
                                required
                                :class="{ error: errors.link }"
                                @input="clearError('link')"
                            >
                            <div v-if="errors.link" class="error-message">
                                Пожалуйста, введите реферальную ссылку
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Подробнее</label>
                        <textarea
                            v-model="description"
                            required
                            :class="{ error: errors.description }"
                            @input="clearError('description')"
                        ></textarea>
                        <div v-if="errors.description" class="error-message">
                            Пожалуйста, заполните поле "Подробнее"
                        </div>
                    </div>

                    <div class="additional-fields">
                        <table>
                            <thead>
                                <tr>
                                    <th>Название поля</th>
                                    <th>Значение</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pair, index) in fieldPairs" :key="index">
                                    <td>
                                        <input
                                            v-model="pair.name"
                                            type="text"
                                            placeholder="Введите название"
                                        >
                                    </td>
                                    <td>
                                        <input
                                            v-model="pair.value"
                                            type="text"
                                            placeholder="Введите значение"
                                        >
                                    </td>
                                    <td class="actions-cell">
                                        <button
                                            v-if="index > 0"
                                            class="icon-btn error small"
                                            @click="removeFieldPair(index)"
                                        >
                                            <span class="material-icons">close</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="dialog-footer">
                    <button class="btn" @click="addFieldPair">
                        Добавить поле
                    </button>
                    <button class="btn primary" @click="saveProduct">
                        {{ editingProduct ? 'Обновить' : 'Сохранить' }}
                    </button>
                    <button class="btn" @click="dialog = false">
                        Отмена
                    </button>
                </div>
            </div>
        </div>
        <div v-if="confirmDialog.visible" class="confirm-overlay">
            <div class="confirm-dialog">
                <div class="dialog-header">
                    <h2>Подтверждение</h2>
                </div>
                <div class="dialog-body">
                    <p>{{ confirmDialog.message }}</p>
                </div>
                <div class="dialog-footer">
                    <button class="btn" @click="confirmDialog.onCancel">Отмена</button>
                    <button class="btn primary" @click="confirmDialog.onConfirm">Подтвердить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        products: [],
        dialog: false,
        editingProduct: null,

        // Типы продуктов
        productTypes: {
            debit: 'Дебетовые карты',
            credit: 'Кредитные карты',
            microcredit: 'МикроКредиты',
            mortgage: 'Ипотека',
        },

        // Обязательные поля
        offerName: '',
        description: '',
        premium: null,
        imageLink: '',
        link: '',

        // Состояние ошибок валидации
        errors: {
            productType: false,
            offerName: false,
            premium: false,
            imageLink: false,
            link: false,
            description: false
        },

        // Данные для окна подтверждения
        confirmDialog: {
            visible: false,
            message: '',
            onConfirm: null,
            onCancel: null
        },

        // Тип продукта
        selectedProductType: null,

        // Дополнительные поля
        fieldPairs: [
            { name: '', value: '' },
            { name: '', value: '' }
        ]
    }),
    computed: {
        productsArray() {
            // Создаем массив структуры для каждого типа
            const types = [
                { title: 'Дебетовые карты', type: 'debit', offers: [] },
                { title: 'Кредитные карты', type: 'credit', offers: [] },
                { title: 'МикроКредиты', type: 'microcredit', offers: [] },
                { title: 'Ипотека', type: 'mortgage', offers: [] }
            ];

            // Группируем продукты за один проход
            this.products.forEach(product => {
                const typeGroup = types.find(t => t.type === product.type);
                if (typeGroup) {
                    typeGroup.offers.push(product);
                }
            });

            // Фильтруем только группы с офферами
            return types.filter(type => type.offers.length > 0);
        },

        companyName() {
            return fullName => fullName ? fullName.split('-')[0].trim() : ''
        }
    },
    methods: {
        validateForm() {
            this.resetErrors(); // Сбрасываем перед проверкой

            // Проверяем обязательные поля
            let isValid = true;

            if (!this.selectedProductType) {
                this.errors.productType = true;
                isValid = false;
            }

            if (!this.offerName.trim()) {
                this.errors.offerName = true;
                isValid = false;
            }

            if (this.premium === null || this.premium === undefined || this.premium === '') {
                this.errors.premium = true;
                isValid = false;
            }

            if (!this.imageLink.trim()) {
                this.errors.imageLink = true;
                isValid = false;
            }

            if (!this.link.trim()) {
                this.errors.link = true;
                isValid = false;
            }

            if (!this.description.trim()) {
                this.errors.description = true;
                isValid = false;
            }

            return isValid;
        },

        openAddDialog(type) {

            this.resetForm();
            this.selectedProductType = type;
            this.resetErrors(); // Сбрасываем ошибки
            this.dialog = true;
        },

        resetForm() {
            this.editingProduct = null;
            this.selectedProductType = null;
            this.offerName = '';
            this.description = '';
            this.premium = null;
            this.fieldPairs = [
                { name: '', value: '' },
                { name: '', value: '' }
            ];
            this.resetErrors(); // Добавляем сброс ошибок
        },
        resetErrors() {
            this.errors = {
                productType: false,
                offerName: false,
                premium: false,
                imageLink: false,
                link: false,
                description: false
            };
        },
        clearError(field) {
            this.errors[field] = false;
        },

        addFieldPair() {
            this.fieldPairs.push({ name: '', value: '' });
        },

        removeFieldPair(index) {
            if (this.fieldPairs.length > 1) {
                this.fieldPairs.splice(index, 1);
            }
        },

        showConfirm(message, onConfirm, onCancel = () => {}) {
            this.confirmDialog = {
                visible: true,
                message,
                onConfirm: () => {
                    onConfirm();
                    this.confirmDialog.visible = false;
                },
                onCancel: () => {
                    onCancel();
                    this.confirmDialog.visible = false;
                }
            };
        },

        showSuccess(message) {
            PNotify.success({
                title: 'Успешно',
                text: message,
                delay: 3000
            });
        },

        showError(message) {
            PNotify.error({
                title: 'Ошибка',
                text: message,
                delay: 5000
            });
        },

        async getProducts() {
            try {
                const response = await axios.get('/bp/products');
                this.products = response.data;
            } catch (error) {
                console.error('Ошибка загрузки продуктов:', error);
                this.showError('Не удалось загрузить продукты');
            }
        },



        async openEditDialog(product) {
            try {
                const response = await axios.get(`/bp/products/${product.id}`);
                const data = response.data;

                this.editingProduct = product.id;
                this.selectedProductType = data.type;
                this.offerName = data.name;
                this.description = data.description;
                this.premium = data.premium;
                this.imageLink = data.image;
                this.link = data.link_format;

                // Загрузка дополнительных полей
                const fields = [];
                if (data.extra_data) {
                    Object.keys(data.extra_data)
                        .sort((a, b) => a - b)
                        .forEach(key => {
                            const field = data.extra_data[key];
                            if (field.name !== 'Категория') {
                                fields.push({
                                    name: field.name,
                                    value: field.value
                                });
                            }
                        });
                }

                this.fieldPairs = fields.length > 0
                    ? fields
                    : [{ name: '', value: '' }, { name: '', value: '' }];

                this.resetErrors();
                this.dialog = true;
            } catch (error) {
                console.error('Ошибка загрузки продукта:', error);
                this.showError('Не удалось загрузить данные продукта');
            }
        },

        async saveProduct() {
            // Валидация
            if (!this.validateForm()) {
                this.showError('Заполните обязательные поля');
                return;
            }

            // Формирование дополнительных полей
            const extra_data = {};
            let hasExtraData = false;
            
            this.fieldPairs.forEach((pair, index) => {
                if (pair.name && pair.value) {
                    extra_data[index] = {
                        name: pair.name,
                        value: pair.value
                    };
                    hasExtraData = true;
                }
            });

            // Подготовка данных
            const productData = {
                name: this.offerName,
                type: this.selectedProductType,
                description: this.description,
                premium: this.premium + '',
                image: this.imageLink,
                link_format: this.link,
                // Передаем null вместо пустого объекта при создании
                extra_data: this.editingProduct ? extra_data : (hasExtraData ? extra_data : null)
            };

            try {
                if (this.editingProduct) {
                    await axios.put(`/bp/products/${this.editingProduct}`, productData);
                    this.showSuccess('Оффер обновлен');
                } else {
                    console.log(productData);
                    await axios.post('/bp/products', productData);
                    this.showSuccess('Оффер создан');
                }

                this.dialog = false;
                this.getProducts();
            } catch (error) {
                console.error('Ошибка сохранения продукта:', error);
                
                let errorMessage = 'Ошибка сохранения';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage += ': ' + error.response.data.message;
                } else if (error.message) {
                    errorMessage += ': ' + error.message;
                }
                
                this.showError(errorMessage);
            }
        },

        deleteProduct(product) {
            this.showConfirm(
                `Удалить оффер "${this.companyName(product.name)}"?`,
                async () => {
                    // Оптимистичное обновление интерфейса
                    this.products = this.products.filter(p => p.id !== product.id);
                    
                    try {
                        await axios.delete(`/bp/products/${product.id}`);
                        this.showSuccess('Оффер удален');
                    } catch {
                        
                    }
                }
            );
        },

        // deleteAllProducts(type, title) {
        //     this.showConfirm(
        //         `Удалить ВСЕ офферы категории "${title}"?`,
        //         async () => {
        //             try {
        //                 await axios.delete(`/bp/products?type=${type}`);

        //                 this.showSuccess(`Все офферы категории "${title}" удалены`);
        //             } catch (error) {
        //                 console.error('Ошибка удаления продуктов:', error);
        //                 this.showError('Не удалось удалить офферы');
        //             } finally {
        //                 this.getProducts();
        //             }
        //         }
        //     );
        // },
    },
    created() {
        this.getProducts();
    }
}
</script>

<style scoped>
/* Базовые стили */
.app-container {
    font-family: 'SFPro';
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.header-section {
    padding-top: 100px;
    margin-bottom: 30px;
}

.header-link {
    color: #00ba57;
    text-decoration: underline;
}

.header-section h1 {
    font-size: 24px;
    margin: 10px 0;
}

/* Секции продуктов */
.product-type-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.product-type-header {
    display: flex;
    gap: 20px;
    justify-content: start;
    align-items: center;
    margin-bottom: 20px;
}

.product-type-header h3 {
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
}

.product-actions {
    display: flex;
    gap: 10px;
}

.products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 20px;
}

.product-card {
    background: white;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    position: relative;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.delete-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #ff5252;
    padding: 4px;
}

.product-content {
    text-align: center;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.product-logo {
    max-height: 60px;
    max-width: 100%;
    margin: 0 auto 15px;
    display: block;
}

.product-name {
    font-size: 16px;
    font-weight: 500;
    color: #34495e;
    line-height: 1.3;
}

/* Диалоговое окно */
.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.dialog-container {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 900px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.dialog-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dialog-header h2 {
    margin: 0;
    font-size: 20px;
}

.dialog-body {
    padding: 20px;
}

.dialog-footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

/* Формы */
.form-group {
    margin-bottom: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.form-row .form-group {
    flex: 1;
    margin-bottom: 0;
}

label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.form-group .error {
    border: 1px solid #ff5252;
}

.error-message {
    color: #ff5252;
    font-size: 12px;
    margin-top: 4px;
}



.confirm-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
}

.confirm-dialog {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.confirm-dialog .dialog-body {
    padding: 20px 0;
    text-align: center;
}

.confirm-dialog .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 15px;
    padding-top: 20px;
}

input, select, textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
}

textarea {
    min-height: 100px;
    resize: vertical;
}

/* Таблица */
.additional-fields table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.additional-fields th {
    text-align: left;
    padding: 10px;
    background: #f5f7fa;
    font-weight: 600;
}

.additional-fields td {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.actions-cell {
    text-align: center;
    width: 60px;
}

/* Кнопки */

.close-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #777;
    font-size: 24px;
    padding: 5px;
}

.close-btn:hover {
    color: #333;
}

.btn {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.btn.primary {
    background-color: #00ba57;
    color: white;
}

.btn.primary:hover {
    background-color: #00ba57;
}

.icon-btn {
    background: #00ba57;
    color: white;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.icon-btn.error {
    background: #ff5252;
    color: white;
}

.icon-btn.error:hover {
    background: rgba(255, 82, 82, 0.1);
}

.icon-btn.small {
    padding: 4px;
}

/* Material Icons */
.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
}

/* Адаптивность */
@media (max-width: 768px) {
    .products-grid {
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    }

    .form-row {
        flex-direction: column;
        gap: 15px;
    }

    .dialog-footer {
        flex-wrap: wrap;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/bank-products/BankingProductsSettings.vue